/** ברירות מחדל לדף ציור ריק (פיקסלים). */

export const BLANK_CANVAS_PRESETS = [
  { w: 800, h: 600, labelHe: '800×600', labelEn: '800×600' },
  { w: 1024, h: 768, labelHe: '1024×768', labelEn: '1024×768' },
  { w: 1200, h: 1200, labelHe: 'ריבוע 1200', labelEn: '1200 sq' },
  { w: 1080, h: 1080, labelHe: 'ריבוע 1080', labelEn: '1080 sq' },
  { w: 1080, h: 1920, labelHe: 'סטורי', labelEn: 'Story' },
  { w: 1920, h: 1080, labelHe: 'רוחב HD', labelEn: 'HD wide' },
  { w: 2480, h: 3508, labelHe: 'A4 עמוד', labelEn: 'A4 portrait' },
  { w: 3508, h: 2480, labelHe: 'A4 לרוחב', labelEn: 'A4 landscape' },
  { w: 2048, h: 2048, labelHe: 'ריבוע 2K', labelEn: '2048 sq' },
]

const STORAGE_W = 'colorphoto_blank_canvas_w'
const STORAGE_H = 'colorphoto_blank_canvas_h'

export function readStoredBlankCanvasSize() {
  if (typeof localStorage === 'undefined') return { w: 800, h: 600 }
  try {
    const w = Number(localStorage.getItem(STORAGE_W))
    const h = Number(localStorage.getItem(STORAGE_H))
    if (Number.isFinite(w) && Number.isFinite(h) && w >= 100 && h >= 100 && w <= 4096 && h <= 4096) {
      return { w: Math.round(w), h: Math.round(h) }
    }
  } catch {
    /* ignore */
  }
  return { w: 800, h: 600 }
}

export function storeBlankCanvasSize({ w, h }) {
  try {
    localStorage.setItem(STORAGE_W, String(w))
    localStorage.setItem(STORAGE_H, String(h))
  } catch {
    /* ignore */
  }
}
